function toFiniteNumber(value) {
  const n = typeof value === "number" ? value : Number(value);
  return Number.isFinite(n) ? n : 0;
}

export function parseMoneyInput(value) {
  const raw = String(value ?? "").trim();
  if (!raw) return null;
  const cleaned = raw.replace(/\s/g, "").replace(/€/g, "");
  if (!cleaned) return null;

  let normalized = cleaned;
  if (cleaned.includes(".") && cleaned.includes(",")) {
    normalized = cleaned.replace(/\./g, "").replace(/,/g, ".");
  } else if (cleaned.includes(",")) {
    normalized = cleaned.replace(/,/g, ".");
  } else if (/^\d{1,3}(\.\d{3})+$/.test(cleaned)) {
    normalized = cleaned.replace(/\./g, "");
  }

  const n = Number.parseFloat(normalized);
  return Number.isFinite(n) ? n : null;
}

export function formatMoneyInput(value) {
  if (value == null || value === "") return "";
  const n = toFiniteNumber(value);
  return new Intl.NumberFormat("de-DE", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(n);
}

function monthlyRecurringAmount(deal) {
  const recurringAmount = toFiniteNumber(deal?.recurring_amount);
  if ((deal?.recurring_interval || "").toLowerCase() === "yearly") {
    return recurringAmount / 12;
  }
  return recurringAmount;
}

function termMonths(deal) {
  const months = Number(deal?.recurring_term_months);
  return Number.isFinite(months) && months > 0 ? months : 12;
}

export function calculateDealMrr(deal) {
  const billingModel = deal?.billing_model || "one_time";
  if (billingModel === "one_time") return 0;
  return monthlyRecurringAmount(deal);
}

export function calculateDealArr(deal) {
  const billingModel = deal?.billing_model || "one_time";
  if (billingModel === "one_time") return 0;
  const recurringAmount = toFiniteNumber(deal?.recurring_amount);
  return (deal?.recurring_interval || "").toLowerCase() === "yearly"
    ? recurringAmount
    : recurringAmount * 12;
}

export function calculateDealTcv(deal) {
  if (deal?.tcv != null && Number.isFinite(Number(deal.tcv))) {
    return Number(deal.tcv);
  }
  const billingModel = deal?.billing_model || "one_time";
  const oneTimeAmount = toFiniteNumber(deal?.one_time_amount);
  if (billingModel === "one_time") {
    return oneTimeAmount || toFiniteNumber(deal?.value);
  }
  return oneTimeAmount + monthlyRecurringAmount(deal) * termMonths(deal);
}

export function calculateWeightedTcv(deal) {
  if (deal?.weighted_tcv != null && Number.isFinite(Number(deal.weighted_tcv))) {
    return Number(deal.weighted_tcv);
  }
  const probability = Math.max(0, Math.min(100, toFiniteNumber(deal?.probability)));
  return calculateDealTcv(deal) * (probability / 100);
}

export function formatRevenueSummary(deal) {
  const billingModel = deal?.billing_model || "one_time";
  if (billingModel === "recurring") {
    return "MRR";
  }
  if (billingModel === "hybrid") {
    return "Hybrid";
  }
  return "Einmalig";
}
